import React from 'react';
import { X } from 'lucide-react';

/**
 * Mobile Menu Drawer (Slide-in from left)
 * Contains the same menu structure as desktop sidebar
 * Only displayed on mobile/tablet screens (<1024px)
 * Premium 250ms ease-in-out animations
 */
const MobileMenuDrawer = ({ isOpen, onClose, children }) => {
  return (
    <>
      {/* Backdrop - Smooth fade with blur */}
      <div
        className={`lg:hidden fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-250 ease-in-out ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      {/* Drawer - Smooth slide with transform */}
      <div 
        className={`lg:hidden fixed inset-y-0 left-0 w-80 max-w-[85vw] z-50 shadow-2xl overflow-hidden transition-transform duration-250 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ willChange: 'transform' }}
      >
        {/* Drawer Content - Full height, scrollable */}
        <div className="h-full overflow-y-auto">
          {children}
        </div>
      </div>
    </>
  );
};

export default MobileMenuDrawer;
